import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import { readOrgLocation } from './lib/orgContext';
import App from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('ไม่พบ element #root');

/**
 * เส้นทางทั้งหมดอยู่ใต้ /o/<slug> เมื่อลิงก์ระบุมูลนิธิ
 *
 * ต้องตั้ง basename ไม่งั้น <Link to="/today"> จะพาออกไปนอก path ของมูลนิธิ
 * แล้ว Pages เสิร์ฟ index.html ที่ไม่มี slug → แอปกลับไปใช้มูลนิธิเริ่มต้น
 * ซึ่งคือการสลับมูลนิธิกลางคันโดยไม่มีใครสั่ง
 */
const { basename } = readOrgLocation();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter basename={basename || undefined}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
